angular.module('am4').controller('mapCtrl', function(map, $state, $scope, $rootScope, mapsService, errorService) {
    var that = this;

    this.map = map;

    that.deactivate = function() {
        that.deactivating = true;

        mapsService.deactivate($state.params.mapId, $state.params.id)
        .then(function() {
            $rootScope.$broadcast('maps:update');
        })
        .catch(function(e) {
            errorService.addError('DEACTIVATE_MAP_ERROR', e);
        })
        .finally(function() {
            that.deactivating = false;
            $scope.closeThisDialog();
        });
    };
});



// WEBPACK FOOTER //
// ./src/app/controllers/mapCtrl.js